/* eslint-disable max-lines */
/* eslint-disable react/no-unstable-nested-components */
import {
  Autocomplete,
  Box,
  createFilterOptions,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { OccupationListEN, OccupationListES } from './OccupationList';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { emplomentStyles as classes } from './EmploymentStyles';
import {
  OCC_PLACEHOLDER,
  REQUIRED,
  PROFESSION_DETAILS,
  EMP_PLACEHOLDER,
  PREVIOUS_EMPLOYER,
} from '../../../constants';
import { autoCompleteOccupation, employedCommon, commonTernary, isBundle } from '../../commonCode';
import { CommonStyles } from '../CommonStyles';
import { productMapping } from '../../../services/productMapping';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';

function Retired({ isBundleCompliance = false }) {
  const { t } = useTranslation();

  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme, productName } = leadGenerationContext;
  const commonStyles = CommonStyles(leadGenerationContext?.theme);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const [occupations, setOccupations] = useState([]);

  useEffect(() => {
    if (leadGenerationContext.language === 'ES') {
      setOccupations(OccupationListES());
    }
    if (leadGenerationContext.language === 'EN') {
      setOccupations(OccupationListEN());
    }
  }, [leadGenerationContext.language]);

  const handleChange = (e) => {
    leadGenerationContext.setIsScreenFourDirty(true);
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFeatureScreenDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setEmploymentInformation({
      ...leadGenerationContext.employmentInformation,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'previousEmployer') {
      employedCommon(e, leadGenerationContext, '* Invalid Previous Employer');
    } else if (e.target.name === 'sourceOfCurrentIncome') {
      employedCommon(e, leadGenerationContext, '* Invalid Source of Current Income');
    } else if (e.target.value.length === 0) {
      leadGenerationContext.setEmploymentInformationErrors({
        ...leadGenerationContext.employmentInformationErrors,
        [e.target.name]: '* Mandatory Field',
      });
    } else {
      leadGenerationContext.setEmploymentInformationErrors({
        ...leadGenerationContext.employmentInformationErrors,
        [e.target.name]: '',
      });
    }
  };

  const handleAutoCompleteChangeRetired = (name, value) => {
    autoCompleteOccupation(name, value, leadGenerationContext);
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option,
  });
  const sortedOccupation = [...occupations].sort((a, b) => a.localeCompare(b));
  return (
    <>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="previousEmployer"
          required={!isBundleCompliance}
          id="previousEmployer_label"
          data-testid="prevEmployerlabel_testid"
          aria-label={
            isBundleCompliance
              ? `${t('Name of your previous employer', {
                  defaultValue: 'Name of your previous employer',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
              : `${t('Previous Employer', {
                  defaultValue: 'Previous Employer',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
          }
          sx={commonStyles.label_title}
        >
          {isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.previousEmployer
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Name of your previous employer', {
                defaultValue: 'Name of your previous employer',
              })}
            </span>
          ) : (
            t('Previous Employer', { defaultValue: 'Previous Employer' })
          )}
        </InputLabel>
        <OutlinedInput
          id="previousEmployer"
          data-testid="prevEmployerInput_testid"
          name="previousEmployer"
          inputProps={{ maxLength: 40, style: { fontSize: '16px' } }}
          sx={[
            commonStyles.outlined_inputs,
            classes.input_disabled_style,
            ...(isBundleCompliance
              ? [
                  {
                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors
                      ?.previousEmployer
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors?.previousEmployer
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  },
                ]
              : []),
          ]}
          slotProps={{
            notchedOutline: {
              sx:
                leadGenerationContext.employmentInformationErrors?.previousEmployer &&
                !isBundleCompliance
                  ? commonStyles.notchedOutlineErr
                  : leadGenerationContext.employmentInformationErrors?.previousEmployer &&
                    isBundleCompliance
                  ? classes.outline_inputs_err_bundle
                  : commonStyles.notchedOutline,
            },
            input: {
              sx: isBundle(productName) && {
                '::-moz-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  fontSize: '16px',
                  opacity: 1,
                },
                '::-webkit-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::-ms-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
              },
            },
          }}
          onChange={handleChange}
          placeholder={
            isBundleCompliance
              ? t(PREVIOUS_EMPLOYER, {
                  defaultValue: PREVIOUS_EMPLOYER,
                })
              : t(EMP_PLACEHOLDER, {
                  defaultValue: EMP_PLACEHOLDER,
                })
          }
          fullWidth
          value={
            leadGenerationContext.employmentInformation?.previousEmployer
              ? leadGenerationContext.employmentInformation.previousEmployer
              : ''
          }
          autoComplete="off"
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          data-testid="prevEmpErr_id"
          role="alert"
        >
          {t(leadGenerationContext.employmentInformationErrors?.previousEmployer, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.previousEmployer,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="occupation"
          required={!isBundleCompliance}
          id="occupation_label"
          data-testid="Occupation_testid"
          aria-label={
            isBundleCompliance
              ? `${t('Profession', { defaultValue: 'Profession' })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`
              : `${t('Occupation', { defaultValue: 'Occupation' })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`
          }
          sx={commonStyles.label_title}
        >
          {productMapping(leadGenerationContext.productName) === 'Elite Account' ||
          productMapping(leadGenerationContext.productName) === 'Libre' ||
          productMapping(leadGenerationContext.productName) === 'Ahorra' ? (
            t('OccupationProg', {
              defaultValue: 'Occupation',
              nsSeparator: '|',
            })
          ) : isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.occupation
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Profession', { defaultValue: 'Profession' })}
            </span>
          ) : (
            t('Occupation', { defaultValue: 'Occupation' })
          )}
        </InputLabel>
        <Autocomplete
          id="occupation"
          data-testid="autocomplete"
          name="occupation"
          options={sortedOccupation}
          getOptionLabel={(option) => option}
          value={
            leadGenerationContext.employmentInformation?.occupation
              ? leadGenerationContext.employmentInformation.occupation
              : null
          }
          onChange={(event, selectedValue) => {
            handleAutoCompleteChangeRetired('occupation', selectedValue);
          }}
          renderInput={(params) => (
            <OutlinedInput
              inputProps={{
                ...params.inputProps,
                style: { fontSize: '16px' },
              }}
              ref={params.InputProps.ref}
              id="occupation"
              name="occupation"
              sx={[
                commonStyles.outlined_inputs,
                ...(isBundleCompliance
                  ? [
                      {
                        '&.Mui-focused': {
                          border: `1px solid ${theme?.palette?.primary?.main}`,
                        },
                      },
                      classes.select_inputs_bundleBorder,
                      commonStyles.outlined_input_bundle,
                      {
                        backgroundColor: leadGenerationContext.employmentInformationErrors
                          .occupation
                          ? '#D5151F1A'
                          : theme?.palette?.fieldsBackground?.main,
                        // border: leadGenerationContext.employmentInformationErrors.occupation
                        //   ? `2px solid ${theme?.palette?.danger?.main}`
                        //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                      },
                    ]
                  : []),
                {
                  padding: !isBundleCompliance && '11.5px 14px !important',
                  fontSize: '16px',
                },
              ]}
              placeholder={
                isBundleCompliance
                  ? t(PROFESSION_DETAILS, {
                      defaultValue: PROFESSION_DETAILS,
                    })
                  : t(OCC_PLACEHOLDER, {
                      defaultValue: OCC_PLACEHOLDER,
                    })
              }
              slotProps={{
                notchedOutline: {
                  sx:
                    leadGenerationContext.employmentInformationErrors?.occupation &&
                    !isBundleCompliance
                      ? commonStyles.notchedOutlineErr
                      : leadGenerationContext.employmentInformationErrors?.occupation &&
                        isBundleCompliance
                      ? classes.outline_inputs_err_bundle
                      : commonStyles.notchedOutline,
                },
                input: {
                  sx: isBundle(productName) && {
                    padding: '14px 14px 10px 14px !important',
                    '::-moz-placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      opacity: 1,
                    },
                    '::placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      fontSize: '16px',
                      opacity: 1,
                    },
                    '::-webkit-input-placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      opacity: 1,
                    },
                    '::-ms-input-placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      opacity: 1,
                    },
                  },
                },
              }}
              fullWidth
              value={
                leadGenerationContext.employmentInformation?.occupation
                  ? leadGenerationContext.employmentInformation.occupation
                  : ''
              }
            />
          )}
          filterOptions={filterOptions}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: theme?.menuBackground,
                color: theme?.palette?.primary?.main,
              },
            },
          }}
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          data-testid="occupationErr-id"
          role="alert"
        >
          {t(leadGenerationContext.employmentInformationErrors?.occupation, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.occupation,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="annualIncome"
          required={!isBundleCompliance}
          id="annualIncome_label"
          data-testid="Annual_testid"
          aria-label={
            isBundleCompliance
              ? `${t('Annual income', {
                  defaultValue: 'Annual income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
              : `${t('Annual Income', {
                  defaultValue: 'Annual Income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
          }
          sx={commonStyles.label_title}
        >
          {isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors.annualIncome
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Annual income', { defaultValue: 'Annual income' })}
            </span>
          ) : (
            t('Annual Income', { defaultValue: 'Annual Income' })
          )}
        </InputLabel>
        <Select
          id="annualIncome"
          data-testid="annulaIncome_testid"
          name="annualIncome"
          role="listbox"
          fullWidth
          variant="outlined"
          IconComponent={() => (
            <Box padding="0 10px 0 0">
              <DownArrowIcon
                style={{ width: 24, height: 24 }}
                color={theme?.palette?.orientalPrimary?.main}
              />
            </Box>
          )}
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                ...theme?.menuBackground,
                border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                color: theme?.palette?.primary?.main,
              },
              className: isBundle(productName) ? 'bundle-menu-paper' : '',
            },
          }}
          aria-label={t('Annual Income Aria Label', {
            defaultValue: 'Annual Income Required Please Select Annual Income dropdown menu button',
          })}
          // sx={[
          //   classes.select_inputs,
          //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
          //     !isBundleCompliance &&
          //     classes.select_inputs_err,
          //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
          //     isBundleCompliance &&
          //     classes.select_inputs_err_bundle,
          //   !leadGenerationContext.employmentInformation?.annualIncome && {
          //     color: '#808285',
          //   },
          //   ...(isBundleCompliance && [
          //     classes.select_inputs_bundleBorder,
          //     commonStyles.outlined_input_bundle,
          //   ]),
          // ]}
          sx={[
            classes.select_inputs,
            leadGenerationContext.employmentInformationErrors?.annualIncome && !isBundleCompliance
              ? classes.select_inputs_err
              : null,
            leadGenerationContext.employmentInformationErrors?.annualIncome && isBundleCompliance
              ? classes.select_inputs_err_bundle
              : null,
            !leadGenerationContext.employmentInformation?.annualIncome
              ? { color: '#808285' }
              : null,
            ...(isBundleCompliance
              ? [
                  {
                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors.annualIncome
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors.annualIncome
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                    color: !leadGenerationContext.employmentInformation?.annualIncome
                      ? theme?.palette?.fieldsPlaceholder?.main
                      : theme?.palette?.primary?.main,
                  },
                ]
              : []),
          ]}
          onChange={handleChange}
          slotProps={{
            icon: {
              sx: classes.select_icon,
            },
            select: {
              sx:
                !leadGenerationContext.employmentInformation?.annualIncome ||
                leadGenerationContext.employmentInformation?.annualIncome === 'Please Select'
                  ? classes.select_inputs_placeholder
                  : classes.select_style,
            },
          }}
          displayEmpty
          value={
            leadGenerationContext.employmentInformation?.annualIncome
              ? leadGenerationContext.employmentInformation.annualIncome
              : ''
          }
        >
          <MenuItem role="option" value="">
            {isBundleCompliance
              ? t('Select your annual income', { defaultValue: 'Select your annual income' })
              : t('Select Annual Income', { defaultValue: 'Select Annual Income' })}
          </MenuItem>
          <MenuItem role="option" value="Less than $30,000">
            {t('Less than', { defaultValue: 'Less than' })} $30,000
          </MenuItem>
          <MenuItem role="option" value="$30,000 - $49,999">
            {t('$30,000 - $49,999', { defaultValue: '$30,000 - $49,999' })}
          </MenuItem>
          <MenuItem role="option" value="$50,000 - $74,999">
            {t('$50,000 - $74,999', { defaultValue: '$50,000 - $74,999' })}
          </MenuItem>
          <MenuItem role="option" value="$75,000 - $99,999">
            {t('$75,000 - $99,999', { defaultValue: '$75,000 - $99,999' })}
          </MenuItem>
          <MenuItem role="option" value="$100,000 - $199,999">
            {t('$100,000 - $199,999', { defaultValue: '$100,000 - $199,999' })}
          </MenuItem>
          <MenuItem role="option" value="$200,000 or More">
            $200,000 {t('or More', { defaultValue: 'or More' })}
          </MenuItem>
        </Select>
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          data-testid="annualErr_id"
          role="alert"
        >
          {t(leadGenerationContext.employmentInformationErrors?.annualIncome, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.annualIncome,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="sourceOfCurrentIncome"
          required={!isBundleCompliance}
          id="sourceOfCurrentIncome_label"
          data-testid="Source_testid"
          aria-label={
            isBundleCompliance
              ? `${t('Source of income', {
                  defaultValue: 'Source of income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
              : `${t('Source of Current Income', {
                  defaultValue: 'Source of Current Income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
          }
          sx={commonStyles.label_title}
        >
          {isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.sourceOfCurrentIncome
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Source of income', {
                defaultValue: 'Source of income',
              })}
            </span>
          ) : (
            t('Source of Current Income', {
              defaultValue: 'Source of Current Income',
            })
          )}
        </InputLabel>
        <OutlinedInput
          id="sourceOfCurrentIncome"
          data-testid="sourceincome_testid"
          name="sourceOfCurrentIncome"
          inputProps={{ maxLength: 100, style: { fontSize: '16px' } }}
          sx={[
            commonStyles.outlined_inputs,
            classes.input_disabled_style,
            ...(isBundleCompliance
              ? [
                  {
                    '&.Mui-focused': {
                      border: `1px solid ${theme?.palette?.primary?.main}`,
                    },
                  },
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors
                      ?.sourceOfCurrentIncome
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors?.sourceOfCurrentIncome
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  },
                ]
              : []),
          ]}
          slotProps={{
            notchedOutline: {
              sx:
                leadGenerationContext.employmentInformationErrors?.sourceOfCurrentIncome &&
                !isBundleCompliance
                  ? commonStyles.notchedOutlineErr
                  : leadGenerationContext.employmentInformationErrors?.sourceOfCurrentIncome &&
                    isBundleCompliance
                  ? classes.outline_inputs_err_bundle
                  : commonStyles.notchedOutline,
            },
            input: {
              sx: isBundle(productName) && {
                '::-moz-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  fontSize: '16px',
                  opacity: 1,
                },
                '::-webkit-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::-ms-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
              },
            },
          }}
          onChange={handleChange}
          placeholder={
            isBundleCompliance
              ? t('Enter your source of income', {
                  defaultValue: 'Enter your source of income',
                })
              : t('Enter Source of Current Income', {
                  defaultValue: 'Enter Source of Current Income',
                })
          }
          fullWidth
          value={
            leadGenerationContext.employmentInformation?.sourceOfCurrentIncome
              ? leadGenerationContext.employmentInformation?.sourceOfCurrentIncome
              : ''
          }
          autoComplete="off"
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          data-testid="sourceErr_id"
          role="alert"
        >
          {t(leadGenerationContext.employmentInformationErrors?.sourceOfCurrentIncome, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.sourceOfCurrentIncome,
          })}
        </Box>
      </Grid>
    </>
  );
}

export default Retired;

Retired.propTypes = {
  isBundleCompliance: PropTypes.bool,
};
